import React from "react";



function AboutSection() {
  return (<>
      <section className="about-section">
     
           
      <div className="overlay">
        <div className="container">
          <h2 className="about-title">Best Ethical Hacking Training Institute in Indore</h2>
          <div className="underline"></div>

          <div className="about-content">
            <p>
              Securtech Lab is one of the most prestigious and best ethical hacking institutes in Indore.
              Our expertise lies in delivering the most comprehensive Ethical Hacking education to make our
              students job-ready.
            </p>

            <p>
              At Securtech, our teachers are highly trained with real-world experience in various companies.
              They bring real-world expertise in cyber security to the classroom making you ready for any challenges
              in the future.
            </p>

            <p>
              Dive deep into the world of ethical hacking and master the essential skills of cybersecurity.
              Through our comprehensive ethical hacking course, you’ll develop expertise in network protection,
              digital forensics, and security assessment.
            </p>

            <p>
              Our program prepares you for prestigious Top Ethical Hacking Certifications like Certified Ethical Hacker
              (CEH) and Computer Hacking Forensic Investigator (CHFI), which are highly valued in the industry.
              Learn cyber security techniques in our modern lab facilities, where theory meets hands-on practice.
            </p>

            <p>
              Our advanced Ethical hacking course follows a step-by-step approach, allowing you to build your
              skills progressively. Each concept you learn can be immediately put into practice, reinforcing
              your understanding and building confidence.
            </p>

            <p>
              This program also includes career guidance and job placement assistance by our facility to help you
              launch your career in the growing field of cybersecurity. Whether you’re starting your journey in
              ethical hacking or advancing your existing skills, our program is designed to make you succeed.
            </p>
          </div>
        </div>
      </div>
    </section>
  </>
);
}

export default AboutSection;
